import { render, staticRenderFns } from "./MiniStatistic.vue?vue&type=template&id=b1a02c8e&"
import script from "./MiniStatistic.vue?vue&type=script&lang=js&"
export * from "./MiniStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MiniStatistic.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VContainer,
  VIcon,
  VTooltip,
})
